import * as React from "react";
import { observer } from "mobx-react-lite";
import { TaskViewVisualStore } from "../stores";
import { Select } from "antd";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: TaskViewVisualStore;
    visible: boolean;
    isSending: boolean;
    setVisible: (visible: boolean) => void;
    sendEmails: (taskId: string, emailAddresses: string[]) => Promise<void>;
};

const TaskSendViaEmailDialog: React.FC<Props> = ({
    visible,
    isSending,
    setVisible,
    sendEmails,
    store,
}) => {
    const [emails, setEmails] = React.useState<string[]>([]);
    const taskId = store.taskPreview?.id;
    React.useEffect(() => {
        if (!visible) {
            setEmails([]);
        }
    }, [visible]);

    if (!taskId) {
        return null;
    }

    return (
        <AppModal
            open={visible}
            title="Send task via email"
            destroyOnClose
            maskClosable={false}
            className="alpha-modal"
            onCancel={() => setVisible(false)}
            cancelButtonTitle="Cancel"
            onCancelClick={() => setVisible(false)}
            cancelButtonProps={{ size: undefined }}
            submitButtonTitle="Send"
            onSubmitClick={() => sendEmails(taskId, emails)}
            submitButtonProps={{
                disabled: isSending || !emails.length,
                loading: isSending,
                size: undefined,
            }}
        >
            <Select
                mode="tags"
                value={emails}
                onChange={(val: unknown) => {
                    setEmails(val as string[]);
                }}
                style={{ width: "100%" }}
                tokenSeparators={[";"]}
                placeholder="Emails"
            />
        </AppModal>
    );
};

export default observer(TaskSendViaEmailDialog);
